import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useAuth } from "../../context/AuthContext";

const HIERARCHY = {
  admin: ["admin", "hr", "storemanager", "manager", "employee"],
  hr: ["hr", "manager", "employee"],
  storemanager: ["storemanager", "employee"],
  manager: ["manager", "employee"],
  employee: ["employee"],
};

function AccessDenied() {
  const navigate = useNavigate();
  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="60vh" gap={2}>
      <LockOutlinedIcon sx={{ fontSize: 64, color: "text.secondary" }} />
      <Typography variant="h5" fontWeight={600}>Access Denied</Typography>
      <Typography color="text.secondary">You do not have permission to view this page.</Typography>
      <Button variant="contained" onClick={() => navigate(-1)}>Go Back</Button>
    </Box>
  );
}

export default function RoleGuard({ allowed = [], access, children, fallback }) {
  const { user, isAuthenticated, hasAccess } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  let ok = false;
  if (access) {
    ok = hasAccess(access);
  } else {
    const role = (user?.role || "").toLowerCase();
    const effective = HIERARCHY[role] || [role];
    const allowedLower = allowed.map((r) => r.toLowerCase());
    ok = effective.some((r) => allowedLower.includes(r));
  }
  if (!ok) {
    if (fallback) return <Navigate to={fallback} replace />;
    return <AccessDenied />;
  }
  return children;
}
